import { ApiClient } from './api-client';

/**
 * User-initiated engagement events sent to the backend ranking system.
 * Impressions are recorded server-side on search — only these user actions
 * are reported from the client.
 */
export type ProviderEventType = 'PROFILE_CLICK' | 'CALL' | 'BOOKING' | 'FAVORITE';

/**
 * Fire-and-forget engagement tracking. The result feeds the provider
 * ranking score (CTR, bookings, …) so the platform rotates visibility
 * fairly instead of always showing the same providers first.
 *
 * Deliberately never returns a promise to await and never throws: a failed
 * tracking beacon must not disrupt navigation or the UI.
 */
export function trackProviderEvent(providerId: string, type: ProviderEventType): void {
  if (!providerId) return;
  void ApiClient.post(`/providers/${providerId}/events`, { type }).catch(() => {
    /* analytics must never break the user experience — swallow it */
  });
}
